import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

import ContentfulImageOrVideo from 'js/src/components/public-pages/ContentfulImageOrVideo';
import type { ImmutableMap } from 'js/src/libs/consts';
import type { ContentfulImageOrVideoData } from 'js/src/libs/contentful-utils';

const CenteredMediaComponent = React.memo(function CenteredMediaComponent({
    data,
    bgColor,
    lazyLoad,
}: {
    data: ImmutableMap<{
        media: ContentfulImageOrVideoData;
        poster_for_video: ContentfulImageOrVideoData;
        caption: Document;
    }>;
    bgColor: string;
    lazyLoad: boolean;
}) {
    let captionNode = null;
    if (data.get('caption')) {
        captionNode = (
            <div className="row">
                <div className="offset-sm-2 col-sm-8">
                    {documentToReactComponents(data.get('caption').toJS())}
                </div>
            </div>
        );
    }
    return (
        <div className="contentful-component centered-media" style={{ backgroundColor: bgColor }}>
            <div className="container">
                <div className="row">
                    <div className="offset-sm-2 col-sm-8">
                        <ContentfulImageOrVideo
                            data={data.get('media')}
                            posterForVideo={data.get('poster_for_video')}
                            urlWidth={800}
                            lazyLoad={lazyLoad}
                        />
                    </div>
                </div>
                {captionNode}
            </div>
        </div>
    );
});

export default CenteredMediaComponent;
